import _ from "lodash";
import { ContentPreviewFactory } from "./ContentPreviewFactory";
import { ButtonIcons } from "./ButtonFactory";
import { ColumnDirectionJustifyCenterAlignCenterFlexFill, ColumnJustifyStartFlex, RowJustifyCenterFlex } from "../commons/Containers";
import { Divider, Typography } from "@mui/material";
import { creativeDownload } from "../../api/Api";



export const HeaderComponent = ({ component }) => {

    const Content = ContentPreviewFactory[component?.format];

    const getUrlHandler =  async (component) => {
        //uploadedFile
        if (component.uploaded_file) {
            return URL.createObjectURL(component.uploaded_file);
        }
        else if (!_.isEmpty(component.external_url)) {
            return component.externalUrl;
        }
        else if (!_.isEmpty(component.creative_id)) {
            return await creativeDownload({ creativeId: component.creative_id });
        }
        return '';
    };

    return (
        Content && <Content component={component} getTextHandler={() => component.text} examples={component.example?.header_text_named_params} getUrlHandler={getUrlHandler} fontSize={"0.8rem"} />
    );

};

export const BodyComponent = ({ component }) => {

    const Content = ContentPreviewFactory['text'];

    return (
        Content && <Content component={component} getTextHandler={() => component.text} examples={component.example?.body_text_named_params} />
    );

};

export const FooterComponent = ({ component }) => {

    const Content = ContentPreviewFactory['text'];

    return (
        Content && <Content component={component} getTextHandler={() => component.text} examples={component.example?.body_text_named_params} fontSize={"0.8rem"} />
    );

};

export const ButtonsComponent = ({ component }) => {

    return (component.buttons && <>
        <ColumnDirectionJustifyCenterAlignCenterFlexFill color={'green'}>
            <ColumnJustifyStartFlex gap={1}>
                {component.buttons.map((button, index) => {
                    const Icon = ButtonIcons[button.type];
                    return <ColumnDirectionJustifyCenterAlignCenterFlexFill key={index}>
                        <Divider flexItem />
                        <RowJustifyCenterFlex key={button.type} gap={1}>
                            {Icon && <Icon />}
                            <Typography>
                                {button.text}
                            </Typography>
                        </RowJustifyCenterFlex>
                    </ColumnDirectionJustifyCenterAlignCenterFlexFill>
                })}
            </ColumnJustifyStartFlex>
        </ColumnDirectionJustifyCenterAlignCenterFlexFill></>);

};

export const ComponentPreviewFactory = {
    'header': HeaderComponent,
    'body': BodyComponent,
    'footer': FooterComponent,
    'buttons': ButtonsComponent,
}